<template>
  <div class="typewriter-container">
    <!-- 纯文本模式 -->
    <div v-if="isTyping && !renderMarkdown && !renderHtml" class="typewriter-content">
      {{ displayedText }}<span v-if="showCursor" class="cursor-blink"></span>
    </div>
    
    <!-- HTML模式 -->
    <div v-else-if="isTyping && !renderMarkdown && renderHtml" class="typewriter-content">
      <div class="content-wrapper">
        <span v-html="displayedText"></span><span v-if="showCursor" class="cursor-blink"></span>
      </div>
    </div>
    
    <!-- Markdown模式 -->
    <div v-else-if="isTyping && renderMarkdown" class="typewriter-content">
      <div class="content-wrapper">
        <vue-markdown :source="displayedText"></vue-markdown>
      </div>
    </div>
    
    <!-- 打字完成后的显示 -->
    <div v-else-if="!renderMarkdown && renderHtml" v-html="text" class="typewriter-content"></div>
    <vue-markdown v-else-if="renderMarkdown" :source="text" class="typewriter-content"></vue-markdown>
    <div v-else class="typewriter-content">{{ text }}</div>
    
    <slot></slot>
  </div>
</template>

<script>
import VueMarkdown from 'vue-markdown'

export default {
  name: 'TypewriterText',
  components: {
    VueMarkdown
  },
  props: {
    text: {
      type: String,
      required: true
    },
    typingSpeed: {
      type: Number,
      default: 30
    },
    showCursor: {
      type: Boolean,
      default: true
    },
    renderHtml: {
      type: Boolean,
      default: false
    },
    renderMarkdown: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      displayedText: '',
      index: 0,
      isTyping: false,
      isCompleted: false
    }
  },
  watch: {
    text(newText) {
      if (newText.length > this.displayedText.length) {
        this.continueTyping();
      } else {
        // 如果文本被重置或改变，重新开始
        this.displayedText = '';
        this.index = 0;
        this.isCompleted = false;
        this.startTyping();
      }
    }
  },
  mounted() {
    this.startTyping();
  },
  methods: {
    startTyping() {
      this.isTyping = true;
      this.isCompleted = false;
      this.typeNextChar();
    },
    continueTyping() {
      if (!this.isTyping) {
        this.startTyping();
      }
    },
    typeNextChar() {
      if (this.index < this.text.length) {
        this.displayedText = this.text.substring(0, this.index + 1);
        this.index++;
        setTimeout(this.typeNextChar, this.typingSpeed);
      } else {
        this.isTyping = false;
        this.isCompleted = true;
        this.$emit('typing-completed', this.text);
      }
    }
  }
};
</script>

<style scoped>
.typewriter-container {
  position: relative;
  display: block;
  width: 100%;
}

.typewriter-content {
  position: relative;
  display: inline-block;
}

.content-wrapper {
  position: relative;
  display: inline-block;
}

.cursor-blink {
  display: inline-block;
  width: 2px;
  height: 16px;
  background-color: #333;
  margin-left: 2px;
  animation: blink 0.8s infinite;
  vertical-align: middle;
  position: relative;
}

.markdown-cursor {
  position: absolute;
  bottom: 0;
  right: -4px;
}

@keyframes blink {
  0% { opacity: 1; }
  50% { opacity: 0; }
  100% { opacity: 1; }
}
</style> 